import rich from "../../assets/images/plan/rich.svg";
import build from "../../assets/images/plan/build.svg";
import incre from "../../assets/images/plan/increase.svg";



export default function WhyListSection() {

  return (
    <section className="why-section">

      <div className="contanier">

        <h1>Why List Your Packages on Bashaarat</h1>

        <div className="why-grid">

          <div className="why-card">
            <img src={rich} alt="icon"/>
            <div>
            <h3>Reach Pilgrims Worldwide</h3>
            <p>
              Showcase your Umrah and Hajj packages to a global audience of pilgrims actively searching for trusted travel providers across multiple countries.
            </p>
            </div>
          </div>

          <div className="why-card">
            <img src={build} alt="icon"/>
            <div>
            <h3>Build Trust with Your Profile</h3>
            <p>
             Establish strong credibility with a dedicated vendor webpage that presents your brand, packages, and reviews to pilgrims worldwide with professionalism and trust.
            </p>
            </div>
          </div>

          <div className=" why-card">
            <img src={incre} alt="icon"/>
            <div>
            <h3>Increase Bookings & Visibility</h3>
            <p>
              Get featured across the platform, including home page and recommended sections, helping you attract more enquiries and bookings from pilgrims around the world.
            </p>
            </div>
          </div>

        </div>

      </div>



    </section>

  );
}